import React from 'react';

import {
  AttendeeFragment,
  AttendeeJoinUngatedSessionMutation,
  AttendeeJoinWebinarFragment,
  AttendeeJoinWebinarLiteMutation,
  AttendeeJoinWebinarMutation,
} from '$/GraphQL/schema/schema';

export type AttendeeJoinParams = {
  joinTime?: string;
  connectionId?: string | null;
};

export type AttendeeJoinResult =
  | AttendeeJoinWebinarMutation['attendeeJoinWebinar']
  | AttendeeJoinWebinarLiteMutation['attendeeJoinWebinar']
  | AttendeeJoinUngatedSessionMutation['attendeeJoinUngatedSession']
  | undefined;

export interface AttendeeContextState {
  loading: boolean;
  attendee: Omit<AttendeeFragment, 'set' | 'ewebinar'> &
    Pick<AttendeeJoinWebinarFragment, 'set' | 'ewebinar'>;
  join: (params?: AttendeeJoinParams) => Promise<AttendeeJoinResult>;
}

export const AttendeeContext = React.createContext<AttendeeContextState>({
  loading: true,
} as AttendeeContextState);

export const useAttendeeContext = () => React.useContext(AttendeeContext);
